export function formatMailListDate(raw: string): string {
  if (!raw) return "";
  const parsed = new Date(raw);
  if (Number.isNaN(parsed.getTime())) return raw;

  const now = new Date();
  const sameDay =
    parsed.getDate() === now.getDate() &&
    parsed.getMonth() === now.getMonth() &&
    parsed.getFullYear() === now.getFullYear();

  if (sameDay) {
    return parsed.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });
  }

  return parsed.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "short",
  });
}

export function formatMailDetailDate(raw: string): string {
  if (!raw) return "";
  const parsed = new Date(raw);
  if (Number.isNaN(parsed.getTime())) return raw;
  return parsed.toLocaleString("fr-FR", {
    weekday: "short",
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function extractSenderLabel(from: string): string {
  const trimmed = from.trim();
  if (!trimmed) return "Expéditeur inconnu";
  const match = trimmed.match(/^([^<]+)</u);
  if (match) return match[1].trim().replace(/^["']|["']$/gu, "");
  return trimmed;
}

/** Ligne liste : destinataire dans Envoyés / Brouillons / file d’envoi. */
export function mailListPeerLabel(options: {
  from: string;
  to?: string;
  sendTo?: string;
  isOutbox?: boolean;
  preferRecipient?: boolean;
}): { label: string; avatarRaw: string } {
  if (options.isOutbox) {
    const dest = (options.sendTo ?? "").trim();
    if (dest) {
      return { label: `À ${extractSenderLabel(dest)}`, avatarRaw: dest };
    }
  }
  if (options.preferRecipient) {
    const dest = (options.to ?? "").trim();
    if (dest) {
      return { label: `À ${extractSenderLabel(dest)}`, avatarRaw: dest };
    }
  }
  return { label: extractSenderLabel(options.from), avatarRaw: options.from };
}
